import { Bell } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { EmailTemplateType } from "@/types/email-templates";

interface EmailPreviewProps {
  previewHtml: string;
  templateType: EmailTemplateType;
}

const EmailPreview = ({ previewHtml, templateType }: EmailPreviewProps) => {
  return (
    <Card className="sticky top-8">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Bell className="h-5 w-5" />
          Email Preview
        </CardTitle>
        <CardDescription>This is how your email will look to recipients. Scroll to see the full preview.</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
          <iframe
            srcDoc={previewHtml}
            className="w-full h-[600px] border-0"
            title="Email Preview"
            sandbox="allow-same-origin allow-scripts"
          />
        </div>
        <Badge variant="outline" className="mt-4">
          {templateType === "conversation_report"
            ? "Conversation Analysis Report"
            : templateType === "meeting_recap"
              ? "Meeting Recap"
              : "Customer Report"}
        </Badge>
      </CardContent>
    </Card>
  );
};

export default EmailPreview;
